export const TotalRevenue = {
  barData: [20, 40, 60, 50, 70, 80, 90, 100, 85, 75, 65, 95],
  lineData: [10, 30, 50, 70, 60, 80, 90, 95, 85, 75, 80, 100],
};

export const CustomerData = {
  colors: ["#19a8a6", "#fab54e", "#1467b0", "#19a8a6"],
  labels: ["Premium", "Pro", "Basic", "Trial"],
  series: [15664, 5546, 2478, 7000],
};

export const GrowthData = [
  {
    name: "Growth",
    data: [5000, 10000, 20000, 15000, 8000, 18000, 22000, 25000],
  },
];

export const StatusData = [{
  name: "Total Closed Landlord",
  data: [30, 5, 25, 35, 10, 15, 10, 10, 10, 10],
}];
